"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _iconsReact = require("../../../../icons-react");
var CreateTicketButton = /*#__PURE__*/_react["default"].memo(function (props) {
  return /*#__PURE__*/_react["default"].createElement(StyledCreateTicketButton, (0, _extends2["default"])({}, props, {
    functional: true,
    title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0442\u0438\u043A\u0435\u0442"
  }), /*#__PURE__*/_react["default"].createElement(StyledCreateTicketIcon, null));
});
CreateTicketButton.displayName = 'CreateTicketButton';
CreateTicketButton.propTypes = {
  className: _propTypes["default"].string
};
CreateTicketButton.defaultProps = {
  className: ''
};
var StyledCreateTicketButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "CreateTicketButton__StyledCreateTicketButton",
  componentId: "sc-djkpzf-0"
})(["height:14px;"]);
var StyledCreateTicketIcon = (0, _styledComponents["default"])(_iconsReact.CreateTicket).withConfig({
  displayName: "CreateTicketButton__StyledCreateTicketIcon",
  componentId: "sc-djkpzf-1"
})(["height:100%;width:auto;"]);
var _default = exports["default"] = CreateTicketButton;